import moment from 'moment'
import DatePicker from "react-datepicker";
require("utility/date-pickers/week_picker.scss");

class WeekPicker extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = { 
            startDate: props.startDate || moment().startOf('week').toDate(),
            endDate: props.endDate || moment().endOf('week').toDate(),
            selectedDate: props.selectedDate || null
        };
    }

    onChange(selectedDate) {
        var startDate = moment(selectedDate, "YYYY-MM-DD").startOf('week').toDate()
        var endDate = moment(selectedDate, "YYYY-MM-DD").endOf('week').toDate()
        this.setState({ selectedDate, endDate, startDate })

        if (this.props.onChange) {
            this.props.onChange(startDate, endDate, selectedDate)
        }
    }

    isSameWeek(date1, date2) {
        var moment1 = moment(date1);
        var moment2 = moment(date2);
        return moment1.week() === moment2.week() && moment1.year() === moment2.year();
    }

    render() {
        var { selectedDate } = this.state
        
        return (
            <div className='weekSelectorContainer'>
                <DatePicker className="form-control"
                    dateFormat="ww/yyyy"
                    selected={selectedDate ? moment(selectedDate) : null}
                    onChange={(date) => this.onChange(date.format("YYYY-MM-DD"))}
                    dayClassName={(date) =>
                        this.isSameWeek(date, selectedDate) ? "react-datepicker__day--selected" : ''
                    }
                    dateFormatCalendar={"MMM yyyy"}
                    showYearDropdown
                />	
            </div>
        );
    }
}

module.exports = WeekPicker;


// WEBPACK FOOTER //
// ./modules/components/utility/date-pickers/WeekPicker.js